import React from 'react';
import PropTypes from 'prop-types';
import { trimLongText } from 'utils/trimLongText';
import ThumbnailOverlay from './ThumbnailOverlay';
import {
  ThumbnailBox,
  ThumbnailWrapper,
  ThumbnailTitle,
  ThumbnailDescription,
  ThumbnailBoxBorder,
} from './styles';

class TemplateTile extends React.Component {
  state = {
    hovered: false,
  };

  handleMouseEnter = () => this.setState({ hovered: true });

  handleMouseLeave = () => this.setState({ hovered: false });

  render() {
    const { title, templateId, templateType, description, thumbnailUrl, onSelect, disablePreview } = this.props;
    const { hovered } = this.state;
    const trimedDescription = description && trimLongText(description, 60, 2);
    const trimedTitle = title && trimLongText(title, 30, 1);
    return (
      <ThumbnailWrapper>
        <ThumbnailBoxBorder
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          hovered={hovered}
        >
          <ThumbnailBox
            url={thumbnailUrl}
          />
          {
            hovered && templateId &&
            <ThumbnailOverlay
              templateId={templateId}
              templateType={templateType}
              onSelect={onSelect}
              disablePreview={disablePreview}
            />
          }
        </ThumbnailBoxBorder>
        <ThumbnailTitle>
          {trimedTitle}
        </ThumbnailTitle>
        <ThumbnailDescription>
          {trimedDescription}
        </ThumbnailDescription>
      </ThumbnailWrapper>
    );
  }
}

TemplateTile.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  templateId: PropTypes.string,
  templateType: PropTypes.string,
  thumbnailUrl: PropTypes.string,
  onSelect: PropTypes.func,
  disablePreview: PropTypes.bool,
};

export default TemplateTile;
